const stats = [
  { value: "40+", label: "curated learning resources" },
  { value: "Offline", label: "designed for zero internet" },
  { value: "Self-paced", label: "learn on your own schedule" },
];

const NucleusStatsSection = () => {
  return (
    <section className="bg-hire-tint-blue py-10 md:py-12 px-4">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-3 divide-y divide-hire-line sm:divide-y-0 sm:divide-x">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="font-poppins py-5 sm:py-0 sm:px-8 first:pl-0 first:pt-0"
            >
              <strong className="block text-primary text-2xl md:text-3xl font-extrabold tracking-[-0.02em] mb-1.5">
                {stat.value}
              </strong>
              <span className="text-gray text-sm leading-snug block">
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NucleusStatsSection;
